<template>
   <b-row>
      <b-col class="col-auto">
         <dropdown-nav ref="dropdownNavMobile" arrow="left">
            <template slot="label">
               <img src="@shared/_assets/img/burger.svg"/>
            </template>
            <div class="dropdown-category-menu ">
               <div class="dropdown-category-menu-scroller">

                  <h6>CATEGORY</h6>
                  <hr class="left my-2"/>
                  <b-nav v-if="user" vertical class="header-nav-list">
                     <b-nav-item :key="customerCategory.id"
                                 @click.stop="$refs.dropdownNavMobile.forceHide()"
                                 :to="{ name: 'customer', params: { id : customerCategory.id }}"
                                 active-class="active"
                                 class="special"
                                 v-for="(customerCategory) in user.customerShopList">
                        {{ customerCategory.webName }}
                     </b-nav-item>
                     <b-nav-item v-if="hasDesignRole"
                                 class="special primary"
                                 active-class="active"
                                 @click.stop="$refs.dropdownNavMobile.forceHide()"
                                 :to="{ name: 'theme-select'}">Trend Shop
                     </b-nav-item>
                  </b-nav>
                  <b-nav vertical class="header-nav-list">
                     <b-nav-item :key="category.id"
                                 active-class="active"
                                 :active="($route.params && $route.params.parentCategory == category.id) || (!$route.params.parentCategory && $route.params && $route.params.id === category.id)"
                                 @click.stop="changeParentCategory(category)"
                                 v-for="(category) in filteredCategories">
                        {{ category.webName }}
                        <b-nav class="mt-2"
                               v-if="selectedCategory && selectedCategory.id === category.id"
                               vertical>
                           <b-nav-item :key="cat.id"
                                       @click.stop="changeCategory(cat)"
                                       active-class="active"
                                       :active="($route.params && $route.params.parentCategory &&  $route.params.id == cat.id )"
                                       v-for="(cat) in selectedCategory.childrenCategoryList">
                              {{ cat.webName || cat.name }}
                           </b-nav-item>
                        </b-nav>
                     </b-nav-item>
                  </b-nav>
                  <br>
                  <h6>COMPANY</h6>
                  <hr class="left my-2"/>
                  <b-nav vertical class="header-nav-list">
                     <b-nav-item active-class="active" @click.stop="$refs.dropdownNavMobile.forceHide()" :key="route.id" :to="route.path.value"
                                 v-for="(route) in filteredNavItems" class="">
                        {{ route.label.value }}
                     </b-nav-item>
                  </b-nav>
                  <br>
                  <div v-if="user && user.supplierList && user.supplierList.length > 0" >
                     <h6>
                        SUPPLIER
                     </h6>
                     <hr class="left my-2"/>
                     <div >
                        <b-nav v-if="user.supplierList.length > 1" vertical class="header-nav-list">
                           <b-nav-item @click.stop="$refs.dropdownNavMobile.forceHide()" active-class="active"
                                       :key="supplier.id" :to="'/supplier/' + supplier.id + '/orders'"
                                       v-for="(supplier) in user.supplierList" class="">
                              {{ supplier.name }}
                           </b-nav-item>
                        </b-nav>
                        <b-nav v-else vertical class="header-nav-list">
                           <b-nav-item @click.stop="$refs.dropdownNavMobile.forceHide()" active-class="active" :to="'/supplier/' + user.supplierList[0].id + '/orders'" class="">
                              Orders
                           </b-nav-item>
                        </b-nav>
                     </div>
                  </div>
               </div>
            </div>
         </dropdown-nav>
      </b-col>
      <b-col>
         <a class="logo" href="/"><img src="@shared/_assets/img/logo-mobile.svg"/></a>
      </b-col>
      <b-col class="col-auto">
         <user-bar v-if="user"></user-bar>
         <login-bar v-else></login-bar>
      </b-col>
   </b-row>
</template>

<script>
import NavbarBase from "./NavbarBase";
import UserBar from "./UserBar";
import LoginBar from "./LoginBar";

export default {
   name: 'pb-navbar-mobile',
   components: {
      'user-bar': UserBar,
      'login-bar': LoginBar
   },
   extends: NavbarBase,
   methods: {
      changeCategory(category) {
         this.$refs.dropdownNavMobile.forceHide();
         this.$router.push({name: 'category', params: {id: category.id, parentCategory: this.selectedCategory.id}});

      },
      changeParentCategory(category) {

         if (category.childrenCategoryList.length > 0) {
            this.toggleCategory(category);
         } else {
            this.$refs.dropdownNavMobile.forceHide();
            this.$router.push({name: 'category', params: {id: category.id}});
            this.selectedCategory = null;
         }
      },
   }
}
</script>

<style lang="scss" scoped>

</style>
